export function store(key: string, filters = {}) {
    try {
        localStorage.setItem(`${key}_filters`, JSON.stringify(filters));
    } catch (_e) {
        console.error("Error on store filters");
    }
}
export function load(key: string, defaultValue: any = []) {
    try {
        const stored = localStorage.getItem(`${key}_filters`);
        return stored ? JSON.parse(stored) : defaultValue;
    } catch (_e) {
        return defaultValue;
    }
}
